import React, { useEffect } from "react";
import { useState } from "react";
import {Route, Routes } from 'react-router-dom';
import {getDatabase, onValue, ref, set as firebaseSet} from 'firebase/database';
import { WaterBar } from "./WaterTracker.js";

export function Profile(props) {
    const [nickName, setNickName] = useState("Your name");
    const [userInput, setUserInput] = useState("");
    const db = getDatabase();

    useEffect(()=> {
        const userRef = ref(db, "accounts/" + props.uid + "/Nickname");
        const userRefOff = onValue(userRef, (snapshot) =>{
            if(snapshot.exists()) {
                const nickName = snapshot.val();
                setNickName(nickName);
            } else {
                setNickName('Your name');
            }

        })
        function cleanup() {
            userRefOff();
        }
        return cleanup;
    })

    function handleChange(event) { // keep track of user input
        setUserInput(event.target.value);
    }

    function handleNickname() {
        setNickName(userInput);
        const db = getDatabase();
        const refString = "accounts/" + props.uid + "/Nickname";
        const nickNameRef = ref(db, refString);
        if(userInput === "" || userInput === null){
            props.setAlertMessage("No name input.");
        } else {
            firebaseSet(nickNameRef, userInput);
        }
    }

    return (
        <div className="profileDiv">
            <div className = "userInfo">
                <img src="img/profile.png" className="profilePic" alt="Profile picture"/>
                <p>{nickName}</p>
                <input onChange={handleChange} className="textInput"></input>
                <button onClick={() => handleNickname()} className="filter-button" aria-label="Changes user's nickname">Change name</button>
            </div>
            <div>
                <p>Welcome to Get Your Life Together, <em>{nickName}</em>!</p>
                <p>Make sure to drink your water!</p>
                <div className='py-5'>
                    <WaterBar target={8} uid={props.uid}/>
                </div>
            </div>
        </div>
    );
}
